import React, { useState, useEffect } from 'react'; 
import dotbtn from 'images/dotbtn.png'; 

import {
  TodoInputBox,
  TodoInput,
  Dotbtn,
  Dotbtnbox,
  TodoinputInner,
  Timetxt,
} from './style';

export default function ProjectSettingTodoListInput({
  value,
  clickModal,
  openTimeModal,
  setInputlist,
  index,
  change,
}) {
  //const [title,setTitle] = useState(value.title);
  const [calTimeSelcet, setCalTimeSelcet] = useState(
    value.time
      ? {
          hour: value.time.split(':')[0],
          minute: value.time.split(':')[1],
          day: 'AM',
        }
      : null,
  );
  const [title, setTitle] = useState(value.title);

  useEffect(() => {
    setCalTimeSelcet(
      value.time
        ? {
            hour: value.time.split(':')[0],
            minute: value.time.split(':')[1],
            day: 'AM',
          }
        : null,
    );
    setTitle(value.title);
  }, [value]);

  const todotextChange = (e) => {
    var v = e.target.value;
    setTitle(v);
    setInputlist((list) => {
      let tempList = JSON.parse(JSON.stringify(list));
      tempList[index].title = v;
      return tempList;
    });
  };
 
  const exampleContainer = { width: 'calc(100vw*(60/375))', zIndex: 1 };

  return (
    <TodoinputInner>
      <TodoInputBox>
        <Timetxt>
          {calTimeSelcet
            ? (parseInt(calTimeSelcet.hour) +
                (calTimeSelcet.day === 'AM' ? 0 : 12) ===
              24
                ? '00'
                : parseInt(calTimeSelcet.hour) +
                  (calTimeSelcet.day === 'AM' ? 0 : 12)) +
              ':' +
              calTimeSelcet.minute
            : ''}
        </Timetxt>
        <div style={exampleContainer} onClick={openTimeModal}></div>

        <TodoInput
          name="To do text"
          type="text"
          placeholder="함께하는 투두리스트 작성"
          value={title}
          onChange={todotextChange}
        />
      </TodoInputBox>
      <Dotbtnbox
        onClick={(e) => {
          clickModal(e, index);
        }}
      >
        <Dotbtn>
          <img src={dotbtn}></img>
        </Dotbtn>
      </Dotbtnbox>
    </TodoinputInner>
  );
}
